import axios from 'axios'

const dpmshttp = {};

dpmshttp.install = function (Vue, options) {
    Vue.prototype.$dpmshttp = axios;
}

export default dpmshttp;


// WEBPACK FOOTER //
// ./src/plugins/dpmsHttp.js